export function getHeaders() {
  const headers = [
    // {
    //   text: '',
    //   width: 50,
    //   className: 'fixed-cell left',
    // },
    {
      text: 'date',
    },
    {
      text: 'waybill_entry.waybill',
    },
    {
      text: 'waybill_entry.code',
    },
    {
      text: 'phone',
    },

    {
      text: 'waybill_entry.qty',
    },
    {
      text: 'waybill_entry.weight',
    },
    {
      text: 'waybill_entry.volume',
    },
    {
      text: 'sign.receiver',
    },
    {
      text: 'cargo_loading.container',
    },
    {
      text: 'remark',
    },
    {
      text: 'actions',
      className: 'fixed-cell left',
      width: 40,
    },
  ];

  return headers;
}
